<template>
  <div class="overflow-auto">
    <!--   <table id="jobstable" class="table table-striped table-bordered table-sm" cellspacing="0" width="100%">
      <thead>
      <tr>
        <th class="th-sm" v-for="column in FEED_SETTINGS.columns" :key="column.id" :width="tdWidth">
          {{ column.label }}<br><input type="text" class="table-search" @input="setFilters(column.id, $event)" placeholder="Search">
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="job in displayedRecords" :key="job.eId">
        <td v-for="column in FEED_SETTINGS.columns" :key="column.id" :data-label="column.label" :width="tdWidth">
          <router-link v-if="column.id === 'title'" :to="{ path: '/job/'+ job.eId}">{{ job.title }}</router-link>
          <span v-else>{{ job[column.id] }}</span>
        </td>
      </tr>
      </tbody>
    </table> 
  -->
    
   
       <b-col lg="6" class="my-1">
        <b-form-group
          label=""
          label-for="filter-input"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="Type to Search Jobs"
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    
   
    <b-table
      :items="displayedJobs"
      :fields="selectedColumns"
      :per-page="perPage"
      :current-page="currentPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :filter="filter"
      :filter-included-fields="filterOn"
      :busy="isLoading"
      sort-icon-left
      responsive="sm"
      stacked="md"
      show-empty
      small
    >
    <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>&nbsp;
          <strong>Curating the jobs. Almost! there..</strong>
        </div>
      </template>
      <template #head(name)="data">
        <span class="text-info">{{ data.label.toUpperCase()  }}</span>
      </template>
      <template #cell(title)="data">
        <router-link class="joblink" v-if="data.value === data.item.title" :to="{ path: '/job/'+ data.item.eId}">{{ data.value }}</router-link>
          <span v-else>{{ data.value }}</span>
      </template>
    </b-table>
    <b-pagination v-model="currentPage" :total-rows="totalpages" :per-page="perPage" align="center" aria-controls="jobs-table"></b-pagination>

    <!-- <b-table id="jobs-table"
      :items="displayedJobs"
      :fields="selectedColumns"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :filter="filter"
      :busy="isLoading"
      :current-page="currentPage"
      :filter-included-fields="filterOn"
      sort-icon-left
      responsive="sm"
      stacked="md"
      show-empty
      small
    >
    <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>&nbsp;
          <strong>Curating the jobs. Almost! there..</strong>
        </div>
      </template>
    <template #head(name)="data">
        <span class="text-info">{{ data.label.toUpperCase()  }}</span>
      </template>
    <template #cell(title)="data">
        <router-link v-if="data.value === data.item.title" :to="{ path: '/job/'+ data.item.eId}">{{ data.value }}</router-link>
          <span v-else>{{ data.value }}</span>
      </template>
    </b-table>
    <div class="jobvite-pagination" v-if="pages > 1">
      <span class="pagination-link" v-if="CURRENT_PAGE > 1" @click="setCurrentPage(CURRENT_PAGE - 1)" >&larr;</span>
      <span class="pagination-link" :class="CURRENT_PAGE === pagenumber ? 'active' : ''" @click="setCurrentPage(pagenumber)" v-for="(pagenumber, i) in pages" :key="i">{{ pagenumber }}</span>
      <span class="pagination-link" v-if="CURRENT_PAGE < pages" @click="setCurrentPage(CURRENT_PAGE + 1)" >&rarr;</span>
    </div> -->
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "JobList",

  data: function () {
    return {
      sortBy: '',
      sortDesc: false,
      isLoading: true,
      sortDirection: 'asc',
      filter: null,
      filters: {},
      filterOn: ['title','category','location','subsidiaryName'],
      selectedColumns: [],
      displayedJobs: [],
      temp_displayedJobs: [],
      currentPage:1
    }
  },

  computed: {
    ...mapGetters(['JOBS', 'FEED_SETTINGS', 'CURRENT_PAGE']),

    displayedRecords() {
      return this.paginate(this.displayedJobs);
    },

    tdWidth() {
      if(document.body.clientWidth > 720) {
        return (100 / this.FEED_SETTINGS.columns.length) + '%';
      }

      return '';
    },

    totalpages(){
        console.log(this.displayedJobs.length)
        return this.displayedJobs.length;
    },
    perPage(){
       console.log(this.FEED_SETTINGS.per_page)
        return this.FEED_SETTINGS.per_page;
    }
  },

  created() {
     if(typeof this.FEED_SETTINGS.columns !== "undefined") {
      this.selectedColumns = this.FEED_SETTINGS.selectedColumns
      this.isLoading = false;

      } else {
      let self = this
      this.GET_FEED_SETTINGS_FROM_API().then(function(){
     
        self.perPage = self.FEED_SETTINGS.per_page
        self.selectedColumns = self.FEED_SETTINGS.selectedColumns
        self.isLoading = false;



      }).then(function(){

        if(!self.JOBS.length) {
           self.isLoading = true;
          self.GET_JOBS_FROM_API().then( function(){
             self.isLoading = false;
            self.resetFilters();
            
             });
        }
        self.resetFilters()
        
      });
      }

    if(this.JOBS.length) {
      this.resetFilters()
    }
    
  },

  methods: {
    ...mapActions([
      'GET_JOBS_FROM_API',
      'GET_FEED_SETTINGS_FROM_API',
    ]),

    paginate (displayedJobs) {
      let from = (this.CURRENT_PAGE * this.perPage) - this.perPage;
      let to = (this.CURRENT_PAGE * this.perPage);

      this.pages = Math.ceil(displayedJobs.length / this.perPage)
      return displayedJobs.slice(from, to);
    },

    setFilters: function(column, e) {
      this.filters[column] = e.target.value;

      let self = this
      this.displayedJobs = this.JOBS.filter(function (job) {
        for (let prop in self.filters) {
          if (job[prop].toUpperCase().indexOf(self.filters[prop].toUpperCase()) === -1) {
            return false
          }
          console.log(job);
        }

        return true
      })

      this.setCurrentPage(1)
    },

    resetFilters: function () {
       this.displayedJobs = this.JOBS
    },

    ...mapMutations({
      setCurrentPage: "SET_CURRENT_PAGE_TO_STATE"
    })

  }
}
</script>

<style>

.jobvite-joblist-container .pagination-link {
  display: inline-block;
  font-size: 14px !important;
  padding: 5px 15px;
  margin: 3px;
  border: 1px solid #444;
  color: white;
  background: #444;
  text-decoration: none;
  cursor: pointer;
  transition: all .2s;
}

.jobvite-joblist-container .pagination-link.active {
  transform: scale(1.2);
  cursor: default;
}

.jobvite-joblist-container .pagination-link:not(.active):hover {
  background: #555;
}

.jobvite-joblist-container .jobvite-pagination {
  padding: 20px;
}
</style>
